module.exports = __webpack_public_path__ + "img/relevant_skills.df039bb6.png";